import { useState, useCallback } from 'react';
import { ImageProps, VideoProps } from '@fiverr-private/media';

const useMedia = (src: VideoProps['src'] | ImageProps['src'], lazyLoad = false) => {
    const [isMediaBroken, setIsMediaBroken] = useState(false);
    const [isMediaLoaded, setIsMediaLoaded] = useState(!lazyLoad);

    const onMediaError = useCallback(() => {
        setIsMediaBroken(true);
    }, []);

    const onMediaLoad = useCallback(() => {
        setIsMediaLoaded(true);
    }, []);

    const showMedia = Boolean(src) && !isMediaBroken;

    return { isMediaLoaded, onMediaError, onMediaLoad, showMedia };
};

export default useMedia;
